var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumbers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_2722)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59721 14.1385C7.01246 14.1385 6.51056 13.9905 6.09153 13.6946C5.67486 13.3963 5.35408 12.9666 5.12917 12.4055C4.90663 11.8421 4.79537 11.1638 4.79537 10.3707C4.79773 9.57765 4.91019 8.90294 5.13272 8.34659C5.35763 7.78788 5.67842 7.36174 6.09508 7.06818C6.51412 6.77462 7.01483 6.62784 7.59721 6.62784C8.1796 6.62784 8.68031 6.77462 9.09934 7.06818C9.51838 7.36174 9.83916 7.78788 10.0617 8.34659C10.2866 8.9053 10.3991 9.58002 10.3991 10.3707C10.3991 11.1662 10.2866 11.8456 10.0617 12.4091C9.83916 12.9702 9.51838 13.3987 9.09934 13.6946C8.68268 13.9905 8.18197 14.1385 7.59721 14.1385ZM7.59721 13.027C8.05176 13.027 8.41042 12.8033 8.67321 12.3558C8.93836 11.906 9.07093 11.2443 9.07093 10.3707C9.07093 9.79309 9.01056 9.30777 8.88983 8.91477C8.76909 8.52178 8.59863 8.22585 8.37846 8.02699C8.15829 7.82576 7.89788 7.72514 7.59721 7.72514C7.14503 7.72514 6.78755 7.95005 6.52477 8.39986C6.26199 8.8473 6.12941 9.50426 6.12704 10.3707C6.12467 10.9508 6.18268 11.4384 6.30105 11.8338C6.42179 12.2292 6.59224 12.5275 6.81241 12.7287C7.03258 12.9276 7.29418 13.027 7.59721 13.027ZM14.537 6.72727V14H13.2195V8.00923H13.1769L11.4759 9.09588V7.88849L13.2835 6.72727H14.537Z",
    fill: "#006580"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_2722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbers);
export default __webpack_public_path__ + "static/media/numbers.baedc062bb1e62616abeb7d87249eedf.svg";
export { ForwardRef as ReactComponent };